import photo from "../images/Login.jpg";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import React, { useState } from "react";
import validator from "validator";
import Modal from "react-bootstrap/Modal";
import OTPmodal2 from "./OTPmodal2";
import { translate } from "../utils";
import { useSelector } from "react-redux";
import { webSettingsData } from "../store/reducers/websettingsReducer";

function PhoneLoginTwo(props) {
    const [PhoneOTPModalShow, setPhoneOTPModalShow] = React.useState(false);
    const [phonenum, setPhonenum] = useState(null);

    // const navigate = useNavigate();

    const [value, setValue] = useState();
    const [error, setError] = useState(
        "",
        setTimeout(() => {
            if (error !== "") setError("");
        }, 5000)
    );

    const websettings = useSelector(webSettingsData);


    const handleGetOtp = () => {
        if (value === undefined) {
            setError("Please enter phone number!");
        } else if (validator.isMobilePhone(value)) {
            setPhonenum(value);
            setPhoneOTPModalShow(true);
        } else {
            setError("Enter a valid phone number");
        }
    };


    return (
        <>
            <div>
                <Modal {...props} size="xl" aria-labelledby="contained-modal-title-vcenter" centered dialogClassName="border-radius-2">
                    <div className="ModalWrapper44" id="ModalWrapper44">
                        <div style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "20px" }} id="login_img4">
                            <img className="ModalImg4" src={photo} alt="" />
                           
                            {/* <div className="logo-text4">
                                <h4>{translate("beautifulltheme")}</h4>
                                <p> {translate("bestinvestment")}</p>
                            </div> */}
                        </div>

                        <div id="modal-content" className="form_login_bg">
                            <Modal.Header closeButton>
                                <Modal.Title id="contained-modal-title-vcenter"></Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <div className="AC">

                                 <div className="d-flex justify-content-center">
                                    <img src={websettings && websettings.web_header_logo} alt="" id="logo4" />
                                 </div>

                                 <h1 className="text-center my-3 fw-bold text-dark">{translate("login")}</h1>

                                   
                                    <form className="mb-2 mt-lg-5 mt-2 pt-xl-5">

                                       <label htmlFor="floatingInput">{translate("Enter Your Mobile Number")}</label>
                                        <div className="my-3">
                                            <PhoneInput  className="phoneInput" placeholder="Enter your phone number" defaultCountry={process.env.REACT_APP_DEFAULT_COUNTRY} international value={value} onChange={setValue} />
                                        </div>

                                        <div className="py-3 d-flex justify-content-center">
                                            <p className="error-msg">{error}</p>
                                            <button
                                                type="button"
                                                className="btn   btn-lg  w-100"
                                                id="submitbutton"
                                                onClick={() => {
                                                    // props.onHide()
                                                    handleGetOtp();
                                                }}
                                            >
                                                {translate("Get Otp")}
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </Modal.Body>
                        </div>
                    </div>
                </Modal>
            </div>

            {phonenum !== null ? (
                <OTPmodal2 setisloginloading={props.setisloginloading} setIsLogout={props.setIsLogout} phonenum={phonenum} onPhonenumHide={props.onHide()} show={PhoneOTPModalShow} onHide={() => setPhoneOTPModalShow(false)} />
            ) : null}
        </>
    );
}

export default PhoneLoginTwo;
